import { render, staticRenderFns } from "./merchantWithdrawalDetails.vue?vue&type=template&id=9d2bdaf8&scoped=true&"
import script from "./merchantWithdrawalDetails.vue?vue&type=script&lang=js&"
export * from "./merchantWithdrawalDetails.vue?vue&type=script&lang=js&"
import style0 from "./merchantWithdrawalDetails.vue?vue&type=style&index=0&id=9d2bdaf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2bdaf8",
  null
  
)

export default component.exports